<div class="modal-header">
    <h4 class="modal-title">Sager der er godkendt af SA, men du mangler at godkende som KA</h4>
    <button (click)="onDismiss()" type="button" data-bs-theme="dark" class="btn-close" aria-label="Close" tabindex="-1"></button>
</div>

<div class="modal-body">
    <table class="table table-hover table-striped table-sm">
        <thead>
            <th scope="col">Sag</th>
            <th scope="col">Kundenr</th>
            <th scope="col">Navn</th>
            <th scope="col">SA Godkendt</th>
        </thead>
        <tbody>
            <tr *ngFor="let case of sakas"
            class="clickable"
            (click)="onCaseClick(case)">
                <td>{{case?.beskrivelse}}</td>
                <td>{{case.glkundenr}}</td>
                <td>{{case.navn1}}</td>
                <td>{{case.konkSaDen | date:'dd-MM-yyyy'}}</td>
            </tr>
        </tbody>
    </table>
</div>
